import { inject, Pipe, PipeTransform } from '@angular/core';
import { LengthUnit, UnitSystemType, WeightUnit } from '@data-access';
import { UnitSystemService } from '../services/unit-system.service';

@Pipe({ name: 'unitResolveValue', standalone: true })
export class UnitResolveValue implements PipeTransform {
  private service = inject(UnitSystemService);

  transform(
    data: Record<WeightUnit, number> | Record<LengthUnit, number>,
    unitSystem: UnitSystemType | null = null,
  ): number {
    return this.service.resolveUnitValue(data, unitSystem);
  }
}
